var MediaHandler = /** @class */ (function () {
    function MediaHandler() {
    }
    MediaHandler.prototype.isGif = function (deviation) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype.getDeviationType = function (deviation) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype.getLargestFullview = function (deviation) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype.getSmallestThumb = function (deviation, options) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype.getSmallestThumbThatFullyCovers = function (deviation, width, height, fallback, options) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype._getThumbsSortedSmallToBig = function (thumbs) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype.getFullviewForSize = function (deviation, width, height) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype._getFullviews = function (deviation) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype.getDeviationFile = function (deviation, fileType) {
        throw new Error('Not implemented');
    };
    MediaHandler.prototype.getThumbSet = function (deviation, options) {
        throw new Error('Not implemented');
    };
    return MediaHandler;
}());
export default MediaHandler;
//# sourceMappingURL=MediaHandler.js.map